import React, { useContext, useEffect, useState } from "react";
import OffcanvasFooter from "../../Helpers/Offcanvasfooter/OffcanvasFooter";
import UserInfo from "./UserInfo";
import UserPreferences from "./UserPreferences";
import UserLocation from "./UserLocation";
import UserPermissions from "./UserPermissions";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";

import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import { useSelector } from "react-redux";
import trans, { isRTL } from "../../../utils";
import {
	useAddUserMutation,
	useEditUserMutation,
	useExpireAllSessionMutation,
} from "../../../Redux/service/Users/AuthUsers";
import AES from "crypto-js/aes";
import Button from "../../Helpers/Button/Button";
import { Modal } from "react-bootstrap";
import Close from "../../Helpers/CloseBtn/Close";
import { useNavigate } from "react-router-dom";
function ExpireAllSessions({ active, setActive }) {
	const [logoutAllSessions, { isLoading }] = useExpireAllSessionMutation();
	const navigate = useNavigate();

	const handleConfirm = async () => {
		try {
			await logoutAllSessions().unwrap();
			navigate("/signin");

			setActive(false);
		} catch (error) {
			console.error("Expire sessions failed:", error);
			toast.error(`${error?.data?.message || "An error occurred"}`, {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};

	return (
		<Modal show={active} centered dir={!isRTL ? "ltr" : "rtl"}>
			<Modal.Header>
				<div className="flex-between w-100">
					<Close
						style="close-32 close"
						close={() => setActive(false)}
						img="Close"
					/>
				</div>
			</Modal.Header>

			<Modal.Body>
				{trans("This account will be logged out from all connected devices.")}
			</Modal.Body>

			<Modal.Footer>
				<Button
					type="default"
					onClick={() => setActive(false)}
					text={trans("Cancel")}
					disabled={isLoading}
				/>
				<Button
					text={trans("Confirm")}
					onClick={handleConfirm}
					type="primary"
					loading={isLoading}
				/>
			</Modal.Footer>
		</Modal>
	);
}

export default function UserBody({ onSuccess, Editvalues }) {
	let { handleClose, isEditing, currentUserId, currentSubUserId, tryRefetch } =
		useContext(popupcontext);
	const inf = useSelector((state) => state.users.user);
	const [active, setActive] = useState(false);

	const [submitAttempt, setSubmitAttempt] = useState(false);
	let [InsertUser, { isLoading: AddLoading }] = useAddUserMutation();
	let [EditUser, { isLoading: EditLoading }] = useEditUserMutation();
	let initialValues = {
		name: "",
		email: "",
		password: null,
		confirmPassword: null,
		phone: null,
		attributes: {
			speedUnit: "kn",
			volumeUnit: "ltr",
			altitudeUnit: "m",
			distanceUnit: "km",
			currency: "AED",
		},
		latitude: null,
		longitude: null,
		expirationTime: null,
		deviceLimit: null,
		userLimit: null,
		parent: inf.id,
		deviceReadonly: isEditing ? Editvalues?.deviceReadonly : false,
		readonly: isEditing ? Editvalues?.readonly : false,
	};
	const passwordValidation = (password) =>
		isEditing
			? Yup.string().nullable()
			: Yup.string()
					.required(trans("Password Is Required"))
					.test("password-rules", "", (value) => {
						if (!value) return true; // let required handle empty

						return (
							value.length >= 12 &&
							/[A-Z]/.test(value) &&
							/\d/.test(value) &&
							/[^A-Za-z0-9]/.test(value)
						);
					});
	const confirmPasswordValidation = (isEditing) =>
		Yup.string()
			.nullable()
			.when("password", (passwordValue, schema) => {
				// Yup ممكن يرجّع Array أحيانًا
				const pwd = Array.isArray(passwordValue)
					? passwordValue[0]
					: passwordValue;

				const hasPassword =
					typeof pwd === "string" ? pwd.trim().length > 0 : !!pwd;

				// ✅ Adding new user: confirm always required
				if (!isEditing) {
					return schema
						.required(trans("Confirm Password Is Required"))
						.oneOf([Yup.ref("password")], trans("Passwords do not match"));
				}

				// ✅ Editing: required ONLY if password is filled
				if (isEditing && hasPassword) {
					return schema
						.required(trans("Confirm Password Is Required"))
						.oneOf([Yup.ref("password")], trans("Passwords do not match"));
				}

				// ✅ Editing + no password: not required
				return schema.notRequired();
			});

	const deviceLimitValidation = (administrator) =>
		Yup.number()
			.integer(trans("Vehicles Limit must be a whole number"))
			.typeError(trans("Vehicles Limit must be a number"))
			.nullable()
			.test(
				"required-if-admin-and-not-readonly",
				trans("Vehicles Limit is required"),
				function (value) {
					const { deviceReadonly, readonly } = this.parent;
					if (
						administrator === true &&
						deviceReadonly === false &&
						readonly === false
					) {
						return value !== undefined && value !== null && value !== "";
					}
					return true;
				},
			);
	const userLimitValidation = (administrator) =>
		Yup.number()
			.integer(trans("User Limit must be a whole number"))
			.typeError(trans("User Limit must be a number"))
			.nullable()
			.test(
				"required-if-admin-and-not-readonly",
				trans("User Limit is required"),
				function (value) {
					const { deviceReadonly, readonly } = this.parent;

					if (
						administrator === true &&
						deviceReadonly === false &&
						readonly === false
					) {
						return value !== undefined && value !== null && value !== "";
					}
					return true;
				},
			);

	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.test(
				"no-leading-space",
				trans("Name cannot start with a space"),
				(value) => {
					if (typeof value !== "string") return false;
					return !/^\s/.test(value);
				},
			)
			.test(
				"no-multiple-spaces",
				trans("Name cannot contain multiple spaces in a row"),
				(value) => {
					if (typeof value !== "string") return false;
					return !/ {2,}/.test(value);
				},
			),
		email: Yup.string()
			.matches(
				/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com)$/,
				trans("Email must be a valid .com email address"),
			)

			.email()
			.required(trans("Email Is Required")),
		password: passwordValidation(),
		confirmPassword: confirmPasswordValidation(isEditing),

		latitude: Yup.number()
			.transform((value, originalValue) => {
				if (typeof originalValue === "string") {
					const trimmed = originalValue.trim();
					if (trimmed.includes(" ")) return NaN;
					const parsed = parseFloat(trimmed);
					return isNaN(parsed) ? NaN : parsed;
				}
				return value;
			})
			.typeError(trans("Latitude must be a number"))
			.min(-90, trans("Latitude must be between -90 and 90"))
			.max(90, trans("Latitude must be between -90 and 90"))
			.nullable(),

		longitude: Yup.number()
			.transform((value, originalValue) => {
				if (typeof originalValue === "string") {
					const trimmed = originalValue.trim();
					if (trimmed.includes(" ")) return NaN;
					const parsed = parseFloat(trimmed);
					return isNaN(parsed) ? NaN : parsed;
				}
				return value;
			})
			.typeError(trans("Longitude must be a number"))
			.min(-180, trans("Longitude must be between -180 and 180"))
			.max(180, trans("Longitude must be between -180 and 180"))
			.nullable(),

		attributes: Yup.object({
			isCustomer: Yup.boolean(),
			contractStartDate: Yup.string().nullable(),
			contractExpireDate: Yup.string().nullable(),
		}),

		deviceLimit: Yup.number()
			.nullable()
			.when("attributes.isCustomer", {
				is: true,
				then: (schema) => schema.notRequired(),
				otherwise: (schema) => deviceLimitValidation(inf.administrator),
			}),

		userLimit: Yup.number()
			.nullable()
			.when("attributes.isCustomer", {
				is: true,
				then: (schema) => schema.notRequired(),
				otherwise: (schema) => userLimitValidation(inf.administrator),
			}),

		expirationTime: Yup.string().required(
			trans("User expiration date is required"),
		),
	});
	const addUser = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			const email = val.email;
			if (val.phone === "") val.phone = null;
			try {
				delete val.parent;
				delete val.confirmPassword;
				const userId = currentSubUserId || currentUserId;
				if (inf.administrator === false && !isEditing) {
					delete val.userLimit;
					delete val.deviceLimit;
					delete val.parent;
				}
				if (val.attributes.isCustomer) {
					val.readonly = true;
					val.deviceLimit = 0;
					val.userLimit = 0;
				}
				// val.email = AES.encrypt(
				// 	val.email,
				// 	process.env.REACT_APP_ENCRYPTION_KEY,
				// ).toString();
				// val.password = AES.encrypt(
				// 	val.password,
				// 	process.env.REACT_APP_ENCRYPTION_KEY,
				// ).toString();
				if (isEditing) {
					if (val.password) setActive(true);
					let EditedUser = await EditUser({ id: userId, val: val }).unwrap();
					toast.success(trans("User Is Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					// Call onSuccess only on success
					onSuccess && (await onSuccess(EditedUser));
					tryRefetch();
					handleClose("form");
				} else {
					let InsertedUser = await InsertUser(val).unwrap();
					toast.success(trans("New User Is Added"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					onSuccess && (await onSuccess(InsertedUser)); // Call onSuccess only on success
					tryRefetch();
					handleClose("form");
				}
			} catch (error) {
				console.log("Error", error);
				addUser.setValues(
					{
						...addUser.values,
						email,
						password: null,
						confirmPassword: null,
					},
					false,
				);

				addUser.setTouched(
					{
						...addUser.touched,
						password: false,
						confirmPassword: false,
						email: false,
					},
					false,
				);

				addUser.setErrors({});
				toast.error(`${error?.data?.message || "An error occurred"}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});
	console.log("addUser", addUser);
	useEffect(() => {
		if (isEditing && Editvalues) {
			const { parent, ...valuesWithoutParent } = Editvalues;
			addUser.setValues(valuesWithoutParent);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [Editvalues]);
	useEffect(() => {
		if (
			!inf.administrator &&
			inf.deviceReadonly === false &&
			inf.readonly === false
		) {
			addUser?.setFieldValue("readonly", true);
		}
	}, []);
	const handleSubmit = (e) => {
		setSubmitAttempt(true);
		addUser.handleSubmit(e);
	};

	if (AddLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	if (EditLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	return (
		<>
			<form onSubmit={handleSubmit} dir={!isRTL ? "ltr" : "rtl"}>
				<UserInfo addData={addUser} />

				<UserPreferences addData={addUser} />
				<UserLocation addData={addUser} />
				<UserPermissions addData={addUser} />

				<OffcanvasFooter addData={addUser} submitAttempt={submitAttempt} />
			</form>
			<ExpireAllSessions setActive={setActive} active={active} />
		</>
	);
}
